<template>
  <div>
    <!-- 고객확인정보 화면 -->
    <div class="content-container">
      <!-- 상단 페이지명, 스텝 -->
      <div class="top-wrap" flex fjb>
        <div class="step-title">
          {{ $t("Verification.step2.smsVerification") }}
        </div>
        <div class="step-number" flex>
          <div class="number active">1</div>
          <div class="number active ml8">2</div>
          <div class="number ml8">3</div>
          <div class="number ml8">4</div>
        </div>
      </div>
      <!-- //상단 페이지명, 스텝 -->
      <!-- 휴대폰 점유 인증 -->
      <div>
        <div class="content">
          <!-- 영문 이름(필수)-->
          <div class="item mt31">
            <div class="sub-title">
              {{ $t("Verification.step2.englishName.title") }}
            </div>
            <div class="input-box authID" flex>
              <el-input
                v-model="data.enSurname"
                placeholder="Surname"
                class="half en-name"
              ></el-input>
              <el-input
                v-model="data.enGivenName"
                placeholder="Given name"
                class="half en-name ml8"
              ></el-input>
            </div>
            <div class="sub keyColor mt4 fs10">
              {{ $t("Verification.step2.englishName.description") }}
            </div>
            <div
              v-if="data.enSurname.length < 2 || data.enGivenName.length < 2"
              class="sub keyColor mt4 fs10"
            >
              {{ $t("Verification.step2.englishName.verify") }}
            </div>
          </div>
          <!-- //영문 이름(필수) -->

          <!-- 국적 확인 -->
          <div class="item mt32">
            <div class="title mb8">
              {{ $t("Verification.step2.carrierCountry.title") }}
            </div>
            <div class="el-input is-disabled top-content">
              <!-- 통신사 국가 -->
              <div
                @click="openNationsModal"
                class="button-wrap select-box foreigner"
              >
                <div class="item">
                  <div class="detail dropdown  fs12">
                    {{ data.nationality }}
                  </div>
                </div>
              </div>
              <div class="sub keyColor mt4 fs10">
                {{ $t("Verification.step2.verificationImpossible") }}
              </div>
              <!-- //통신사 국가 -->
            </div>
          </div>
          <!-- //국적 확인 -->

          <!-- 휴대폰 번호 -->
          <div class="item mt12">
            <div class="sub-title">
              {{ $t("Verification.step2.phoneNumber.title") }}
            </div>
            <div class="input-box authID" flex fjb>
              <div class="detail en-name nation-code ta-c">
                {{ cntlocalcode }}
              </div>
              <div class="phone-number">
                <el-input
                  v-model="data.personalCode"
                  type="number"
                  pattern="\d*"
                  :placeholder="
                    $t('Verification.step2.phoneNumber.description')
                  "
                  class="en-name"
                ></el-input>
              </div>
            </div>
          </div>
          <!-- //휴대폰 번호 -->

          <!-- 인증 번호 -->
          <div class="item mt12">
            <div class="sub-title">
              {{ $t("Verification.step2.phoneCertificationNumber.title") }}
            </div>
            <div class="input-box authID" flex fjb>
              <div class="auth-number">
                <el-input
                  v-model="data.authNumber"
                  type="number"
                  pattern="\d*"
                  :placeholder="
                    $t(
                      'Verification.step2.phoneCertificationNumber.insertNumber',
                    )
                  "
                  class="en-name"
                ></el-input>
              </div>

              <button
                @click="clickReceiveAuthNumber"
                class="receive-authnumber"
              >
                {{
                  $t("Verification.step2.phoneCertificationNumber.getNumber")
                }}
              </button>
              <div v-if="countdown">{{ remain }}</div>
            </div>
          </div>
          <!-- //인증 번호 -->
          <div class="bottom-button-wrap bottom mt30" flex fjb>
            <button @click="toStep1" class="next-button pre">
              {{ $t("Verification.common.pre") }}
            </button>
            <button
              @click="toStep3"
              :disabled="
                data.enSurname.length < 2 ||
                  data.enGivenName.length < 2 ||
                  data.nationality == locale ||
                  data.personalCode == '' ||
                  data.authNumber == ''
              "
              class="next-button next"
            >
              {{ $t("Verification.common.next") }}
            </button>
          </div>
        </div>
      </div>
      <!-- //휴대폰 점유 인증 -->
    </div>
    <!-- //고객확인정보 화면 -->
    <!-- 통신사 국가 선택 팝업 -->
    <el-dialog
      :visible.sync="data.nationsModal"
      :title="$t('Verification.popup.selectedYourNationality')"
      :close-on-click-modal="false"
      class="authID-modal"
    >
      <el-radio-group v-model="data.nationality" @change="changeNationseModal">
        <ul class="dropdown-list">
          <li
            v-for="(item, index) in data.nationItems"
            :key="index"
            class="pl12"
          >
            <el-radio :label="item.cntName + '/' + item.cntNameKo"></el-radio>
          </li>
        </ul>
      </el-radio-group>
    </el-dialog>
    <!-- // 통신사 국가 선택 팝업 -->
  </div>
</template>
<script>
import Api from "@/common/Api";
import Moment from "moment";

export default {
  props: {
    data: {
      enSurname: String, // 영어 성
      enGivenName: String, // 영어 이름
      nationality: String, // 통신사 국가 확인
      nationsModal: Boolean, // 통신사 국가 선택 팝업
      nationItems: Array, // 통신사 국가 선택 data arra
      authNumber: String, // 인증번호
      personalCode: String, // 휴대폰번호
      mobNumber: String, // api return 휴대폰번호
    },
    cntlocalcode: String, // 선택한 통신사 국가 번호
    locale: String,
  },
  components: {},
  created() {},
  data() {
    return {
      countdown: false,
      remain: "00:00",
      expire: +Moment().add(5, "minutes"),
    };
  },
  methods: {
    // 통신사 국가 선택 팝업
    async openNationsModal() {
      try {
        const res = await Api.getCountry();
        const exception = res.data.result; // 국가 선택 data
        // this.data.nationItems = exception.filter(ele => ele.cntidx !== 17); // 대한민국 제외
        this.data.nationItems = exception; // 대한민국 포함. 테스트용
      } catch (error) {}
      this.data.nationsModal = true;
    },
    // 통신사 국가 버튼 선택 시
    changeNationseModal() {
      this.data.nationsModal = false; //팝업 닫힘
    },
    // step1로 이동
    toStep1() {
      this.$emit("tostep1");
    },
    // step3로 이동
    async toStep3() {
      const params2 = {
        mobNumber: this.data.personalCode,
        cntLocalCode: this.cntlocalcode.slice(1),
        certificationNum: this.data.authNumber,
      };
      try {
        const res = await Api.verifySMSAuthNumber(params2);
        this.data.mobNumber = res.data.result.mobNumber;
        this.$emit("tostep3");
      } catch (error) {
        this.$vs.notify({
          text: "인증번호를 다시 확인해 주세요.",
          type: "warning",
          customClass: "FLYBIT-noti",
          position: "top-left",
        });
      }
    },
    // 인증번호 받기
    async clickReceiveAuthNumber() {
      this.countdown = true;
      const params = {
        mobNumber: this.data.personalCode,
        cntLocalCode: this.cntlocalcode.slice(1),
      };
      try {
        await Api.SMSAuthNumber(params);
        this.$vs.notify({
          text: "인증번호를 발송 했습니다.",
          customClass: "FLYBIT-noti",
          position: "top-left",
        });
        setInterval(this.remainTime, 1000);
        this.expire = +Moment().add(5, "minutes");
        this.remainTime();
      } catch (error) {
        this.$vs.notify({
          text: "인증번호 발송을 실패했습니다.",
          customClass: "FLYBIT-noti",
          position: "top-left",
        });
      }
    },
    remainTime() {
      const remain = Moment(+this.expire - +Moment());
      if (+remain > 0) {
        this.remain = remain.format("mm:ss");
      } else {
        this.countdown = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.defaultColor {
  color: #333;
}
.keyColor {
  color: #eb3246;
}
.content-container {
  .result {
    .item-box {
      border-bottom: 1px solid #afafaf;
    }
  }
}
.authID-container {
  .title-wrap {
    position: relative;
    padding: 7px 0;
    border-bottom: 1px solid #eef0f3;
    .title {
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      color: #222222;
    }
    .close-button {
      position: absolute;
      top: 3px;
      right: 12px;
    }
  }
  .step {
    .top-wrap {
      .step-title {
        font-size: 14px;
        font-weight: 500;
      }
    }
    .content-title {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.29;
      color: #333;
    }
    .content {
      .item {
        width: 100%;
        // margin-top: 12px;
        .sub-title {
          margin-bottom: 8px;
          font-size: 12px;
          font-weight: normal;
          line-height: 1.5;
          color: #333;
        }
        .detail {
          padding: 11px 0 11px 8px;
          border-radius: 2px;
          border: solid 1px #dcdfe3;
          background-color: #f7f8fa;
          &.full-box {
            height: 38px;
            color: #333;
            background-color: #fff;
          }
          &.dropdown {
            position: relative;
            color: #afafaf;
            background-color: #fff;
            &:after {
              content: "";
              position: absolute;
              top: 13px;
              right: 9px;
              width: 6.7px;
              height: 12px;
              background-image: url("../../../../../../assets/img/mypage/button_arrow_right_icon.svg");
              background-size: 6.7px 12px;
              background-repeat: no-repeat;
            }
            &.selected {
              color: #333;
              border: solid 1px #00b473;
              background-color: #f2fbf8;
            }
            &.change {
              color: #333;
              border: solid 1px #00b473;
              background-color: #f2fbf8;
            }
            &.reject {
              color: #333;
              border: solid 1px #eb3246;
              background-color: #fff;
            }
          }
        }
        .input-box {
          .en-name.half {
            width: calc((100% - 12px) / 2);
          }
          .nation-code {
            width: 40px;
            padding: 11px 0;
          }
          .phone-number {
            width: calc(100% - 48px);
          }
          .auth-number {
            width: calc(100% - 92px);
          }
          .send-authnumber {
            width: 82px;
          }
        }
      }
    }
  }
  // 하단 버튼
  button.next-button {
    width: 100%;
    padding: 10px 0;
    font-size: 12px;
    border-radius: 2px;
    border: 1px solid #00b473;
    background-color: #00b473;
    &.pre {
      width: 96px;
      color: #333;
      border: 1px solid #eeeeee;
      background-color: #fff;
      &:disabled {
        border: solid 1px #dadada !important;
        background-color: #dadada !important;
      }
    }
    &.next {
      width: calc(100% - 104px);
    }
    &.bottom {
      position: absolute;
      bottom: 32px;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 24px);
    }
    &:disabled {
      border: solid 1px #dadada !important;
      background-color: #dadada !important;
    }
  }
  button.receive-authnumber {
    width: 84px;
    padding: 4px 0;
    font-size: 12px;
    border-radius: 2px;
    background: #333;
  }
  .button-wrap {
    position: relative;
    &.select-box {
      button.default {
        padding: 10px 9px;
      }
    }
    .detail-noti {
      color: #afafaf;
    }
  }
  .bottom-button-wrap {
    width: 100%;
  }
}
// step number
.step-number {
  .number {
    width: 20px;
    height: 20px;
    text-align: center;
    color: #dcdfe3;
    border-radius: 2px;
    background-color: #f7f8fa;
    &.active {
      color: #fff;
      background-color: #333;
    }
  }
}
.dropdown-list {
  list-style: none;
  li {
    padding: 20px 12px;
    font-size: 12px;
    font-weight: 500;
    ul {
      list-style: none;
    }
  }
}
</style>
